import { useState } from "react";
// import { debugLogger } from "../utils/LogDebug";

const usePriceCalculation = (reservationData, setReservationData) => {
    const [pricePax, setPricePax] = useState(null);

    // Fonction pour calculer le prix et mettre à jour `reservationData`
    const calculatePrice = (priceCalculated) => {
        setPricePax(priceCalculated);  // Mise à jour pricePax pour le return de la fonction

        // Met à jour le prix (dans la réservation)
        setReservationData((prev) => ({
            ...prev,
            prix_cash: parseInt(priceCalculated.cash * 100),
            prix_cb: parseInt(priceCalculated.cb * 100),
        }));

        // Mise a jour des durees et delais (dans la réservation)
        const row = priceCalculated;
        const isDepartToArrive = row.from === reservationData.depart && row.to === reservationData.arrive;
        setReservationData((prev) => ({
            ...prev,
            duree_t1: isDepartToArrive ? row.duree_aller : row.duree_retour,
            duree_t2: isDepartToArrive ? row.duree_retour : row.duree_aller,
            delai_depart_t1: isDepartToArrive ? row.delai_depart : row.delai_arrive,
            delai_arrive_t1: isDepartToArrive ? row.delai_arrive : row.delai_depart,
            delai_depart_t2: isDepartToArrive ? row.delai_depart : row.delai_arrive,
            delai_arrive_t2: isDepartToArrive ? row.delai_arrive : row.delai_depart,
            cp_depart: isDepartToArrive ? row.cp_depart : row.cp_arrive,
            cp_arrive: isDepartToArrive ? row.cp_arrive : row.cp_depart,
            // type_pu_t1: isDepartToArrive ? row.depart_type : row.arrive_type,
            // type_drop_t1: isDepartToArrive ? row.arrive_type : row.depart_type,
            // type_pu_t2: isDepartToArrive ? row.arrive_type : row.depart_type,
            // type_drop_t2: isDepartToArrive ? row.depart_type : row.arrive_type,
        }));

        // debugLogger.log("DANS usePriceCalculation");
        // debugLogger.log({"row.from": row.from, "reservationData.depart": reservationData.depart, "depart_type": reservationData.depart_type, "arrive_type": reservationData.arrive_type});
        // debugLogger.log({"row.to": row.to, "reservationData.arrive": reservationData.arrive, "depart_type": reservationData.depart_type, "arrive_type": reservationData.arrive_type});
        // debugLogger.log({"isDepartToArrive": isDepartToArrive, "row": row});
        // debugLogger.log({"isDepartToArrive": isDepartToArrive, "cp_arrive": reservationData.cp_arrive, "cp_depart": reservationData.cp_depart});

    };

    return { pricePax, calculatePrice };
};

export default usePriceCalculation;
